import { httpClient } from './httpClient';
import { UserProfile, UserProfileUpdate } from '../types/user';
import logger from '../utils/logger';

export class UserService {
  /**
   * Get current user's profile
   */
  static async getMyProfile(): Promise<UserProfile> {
    try {
      logger.debug('🔄 [UserService] Getting user profile...');
      const response = await httpClient.get<UserProfile>('/users/me');
      logger.debug('✅ [UserService] User profile retrieved:', response);
      return response;
    } catch (error) {
      logger.error('❌ [UserService] Error getting user profile:', error);
      throw error;
    }
  }

  /**
   * Update current user's profile
   */
  static async updateMyProfile(data: UserProfileUpdate): Promise<UserProfile> {
    try {
      logger.debug('🔄 [UserService] Updating user profile:', data);
      const response = await httpClient.put<UserProfile>('/users/me', data);
      logger.debug('✅ [UserService] User profile updated:', response);
      return response;
    } catch (error) {
      logger.error('❌ [UserService] Error updating user profile:', error);
      throw error;
    }
  }
}